module.exports = __webpack_public_path__ + "img/icn-ytb.42b43787.svg";